export default __webpack_public_path__ + "mma-pre.png";